import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { Page, TLCode } from '../../common/enums';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { observer } from 'mobx-react';
import BaseGridXL from '../common/grid/BaseGridXL';
import styled from '@emotion/styled';
import { IconNames } from '@blueprintjs/icons';
import { Button, Intent, Tooltip, Label } from '@blueprintjs/core';
import { Position } from '@blueprintjs/core/lib/esm/common/position';
import { Form } from 'react-final-form';
import { BankHolidayDateSearchCriteria } from '../../store/BankHolidayDateStore';
import { BankHoliday } from '../../store/models/BankHoliday';
import { BankHolidayDate } from '../../store/models/BankHolidayDate';
import BankHolidayDateForm from './BankHolidayDateForm';
import { dateFilterNormal, renderGridDate } from '../../store/utils';
import moment from 'moment';
import ActionCell from '../common/grid/ActionCell';

const ButtonsContainer = styled.div({
  display: 'flex',
  alignContent: 'center',
  justifyContent: 'flex-end',
  marginBottom: 5,
});

interface BankHolidayDateManagerProps extends WithTranslateProps {
  bankHolidayDates: any[];
  searchCriteria: Instance<typeof BankHolidayDateSearchCriteria>;
  bankHolidayDateSearchCriteria: Instance<typeof BankHolidayDateSearchCriteria>;
  onSearch: (criteria: any) => void;
  onChangeCriteria: (direction: number) => void;
  onBankHolidayDateSave: (bhd: Instance<typeof BankHolidayDate>) => void;
  onBankHolidayDateDelete: (bhd: Instance<typeof BankHolidayDate>) => void;
  bankHolidayList: Array<Instance<typeof BankHoliday>>;
  bankHolidayDateList: any[];
  navigate: (url: string) => void;
}

interface BankHolidayDateManagerState {
  bankHolidayDateEdition?: Instance<typeof BankHolidayDate>;
}

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContainerSearchForm = styled.div`
  display: flex;
  flex: 0;
  flex-direction: row;
  .bp3-form-content {
    margin-right: 5px;
  },
`;

const ContainerGrid = styled.div`
  display: flex;
  flex-direction: row;
  width: 400px;
  flex: 1;
`;

const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DivColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 50%;
  height: 600px;
  justify-content: space-between;
`;

@observer
class BankHolidayDateManager extends React.Component<BankHolidayDateManagerProps, BankHolidayDateManagerState> {
  state = {
    searchCriteria: this.props.bankHolidayDateSearchCriteria,
    missingBlackPoint: [],
    bankHolidayDates: [],
    bankHolidayDateEdition: undefined,
  } as BankHolidayDateManagerState;

  columns = [
    {
      headerName: this.props.translate(TLCode.PHARMACY_Level),
      field: 'bkname',
      suppressMenu: true,
      width: 350,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY_Level),
      field: 'bkcode',
      suppressMenu: true,
      width: 350,
    },
    {
      headerName: this.props.translate(TLCode.BANK_HOLIDAY_DATES_Title),
      field: 'date',
      suppressMenu: true,
      width: 200,
      sort: 'asc',
      cellRenderer: renderGridDate,
      filterParams: {
        textCustomComparator: dateFilterNormal,
      },
    },
    {
      headerName: '',
      width: 100,
      cellRendererFramework: ActionCell,
      cellRendererParams: (params: ICellRendererParams) => {
        return {
          onEditButtonClick: () => {
            // navigate(`${Page.PharmacyPage}/${params.data.pharmacyId}`);
          },
        };
      },
    },
  ] as ColDef[];

  buildGridData = () => {
    return this.props.bankHolidayDateList.map((ss) => ({
      ...ss,
      date: ss.date,
      bkname: ss.bankHoliday.name,
      bkcode: ss.bankHoliday.code,
    }));
  };

  handleChangeValue = (value) => {
    // this.setState({ searchCriteria: value });
  };

  startEdition = (id: number) => {
    const bhd = this.props.bankHolidayDateList.find((elem) => elem.bankHolidayDateId === id);
    this.setState({ bankHolidayDateEdition: bhd });
  };

  stopEdition = () => {
    this.setState({ bankHolidayDateEdition: undefined });
  };

  save = (data: any) => {
    const bh = this.props.bankHolidayList.find((item) => item.code === data.code);
    data.bankHolidayId = bh ? bh.bankHolidayId : -1;
    data.date.setTime(data.date.getTime() + 4 * 60 * 60 * 1000); // pour éviter les problèmes d etime zone
    this.props.onBankHolidayDateSave(data);
    this.stopEdition();
  };

  render() {
    const { bankHolidayDateEdition } = this.state;
    const { translate, bankHolidayList } = this.props;
    return (
      <Container>
        <ButtonsContainer>
          <Button
            text={translate(TLCode.Add)}
            intent={Intent.PRIMARY}
            onClick={() => {
              this.setState({
                bankHolidayDateEdition: BankHolidayDate.create({
                  bankHolidayDateId: 0,
                  bankHolidayId: 0,
                  date: moment().format('yyyy-MM-dd'),
                }),
              });
            }}
          />
          &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="http://www.public-holidays.us/BE_FR_2020_All" target="_blank">
            Site de référence
          </a>
        </ButtonsContainer>
        <BankHolidayDateForm
          bankHolidayDate={bankHolidayDateEdition}
          bankHolidayList={bankHolidayList}
          onSave={this.save}
          onStop={this.stopEdition}
        />
        <Form onSubmit={this.props.onSearch} initialValues={{ filter: this.props.searchCriteria }}>
          {({ handleSubmit }) => (
            <ContainerSearchForm>
              <Tooltip
                content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_PreviousYear)}
                position={Position.BOTTOM}
                hoverOpenDelay={750}
              >
                <Button
                  icon={IconNames.CHEVRON_LEFT}
                  large={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => this.props.onChangeCriteria(-1)}
                />
              </Tooltip>
              <Label
                style={{
                  justifyContent: 'center',
                  fontWeight: 'bold',
                  fontSize: '25px',
                  verticalAlign: 'center',
                }}
              >
                {this.props.searchCriteria.year}
              </Label>
              <Tooltip
                content={translate(TLCode.MULTI_CALENDAR_TOOLBOX_NextYear)}
                position={Position.BOTTOM}
                hoverOpenDelay={750}
              >
                <Button
                  icon={IconNames.CHEVRON_RIGHT}
                  large={true}
                  style={{ height: '30px', marginLeft: '5px' }}
                  onClick={() => this.props.onChangeCriteria(1)}
                />
              </Tooltip>
            </ContainerSearchForm>
          )}
        </Form>
        {(this.props.bankHolidayDateList || true) && (
          <Container>
            <DivLine>
              <DivColumn>
                <BaseGridXL
                  columnDefs={this.columns}
                  rowData={this.buildGridData()}
                  keyName={'bankHolidayDateId'}
                  suppressClickEdit={true}
                />
              </DivColumn>
            </DivLine>
          </Container>
        )}
      </Container>
    );
  }
}

export default withTranslate(BankHolidayDateManager);
